(function () {
  async function update(indicator, cartQuantity) {
    const stockShopify = parseInt(indicator.dataset.stockShopify) || 0;
    const stockDisponible = parseInt(indicator.dataset.stockDisponible) || 0;
    const descatalogado = indicator.dataset.descatalogado === "true";
    const id_erp = indicator.dataset.id_erp;

    const availableText = window.translations?.availableText || "Disponibles";
    const backorderText = window.translations?.backorderText || "en 2 días";
    const remainingText = window.translations?.remainingText || "Restante";
    const askText = window.translations?.askText || "Contáctanos";

    const stockMostrar = stockShopify > 10 ? "+10" : stockShopify.toString();

    if (descatalogado) {
      indicator.dataset.inventoryLevel = stockShopify === 0 ? "very_low" : "low";
    } else {
      indicator.dataset.inventoryLevel = stockShopify <= 0 ? "backordered" : "normal";
    }

    if (cartQuantity <= stockShopify) {
      indicator.textContent = stockMostrar;
    } else {
      const mensajes = [];
      mensajes.push(`${stockShopify} ${availableText}`);
      if (stockDisponible !== 0) mensajes.push(`${stockDisponible} ${backorderText}`);

      if (id_erp && typeof getDateStock === "function") {
        try {
          const dateStock = await getDateStock(id_erp, cartQuantity);
          if (dateStock.status === "success" && dateStock.date) {
            mensajes.push(`${remainingText} ${dateStock.date}`);
          } else {
            mensajes.push(`${remainingText} ${askText}`);
          }
        } catch (error) {
          mensajes.push(`${remainingText} ${askText}`);
        }
      } else {
        mensajes.push(`${remainingText} ${askText}`);
      }

      indicator.innerHTML = mensajes.join("<br>");
    }
  }

  /**
   * Calcula el máximo de unidades pedibles (entregables) de una variante.
   *
   * Única fuente de verdad del tope anti-overselling. Solo las variantes OUTLET
   * (descatalogado) tienen tope: como están descatalogadas no se reponen más allá
   * de lo que el ERP ya tiene asignado, así que el máximo entregable es el stock
   * físico actual de Shopify (clamp ≥0) MÁS la reposición ERP futura
   * (`stock_disponible`). El problema que resuelve: estas variantes se marcan como
   * "Seguir vendiendo" en Shopify, por lo que sin tope se podría pedir cantidad
   * ilimitada y vender más de lo entregable.
   *
   * Las variantes normales devuelven `null` (sin tope: el backorder / reposición
   * continua del ERP no está acotado por este criterio).
   *
   * @param {Object} args
   * @param {boolean} args.descatalogado   - true si la variante es outlet.
   * @param {number|string} args.stockShopify    - inventory_quantity / quantityAvailable actual.
   * @param {number|string} args.stockDisponible - metafield upng.stock_disponible (reposición ERP futura).
   * @returns {number|null} Tope entero (≥0), o `null` si la variante no tiene tope.
   */
  function getMaxOrderable({ descatalogado, stockShopify, stockDisponible } = {}) {
    if (!descatalogado) return null;
    const current = Math.max(0, parseInt(stockShopify, 10) || 0);
    const future = parseInt(stockDisponible, 10) || 0;
    return current + future;
  }

  window.UpngStockDisplay = { update, getMaxOrderable };
})();
